import { useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ContainerButton from '../../../components/button/ContainerButton';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import { Avatar, Box, Checkbox, FormControlLabel, Grid, IconButton, Radio, RadioGroup, Typography } from '@mui/material';
import { debouncedApiCall, handleTypingNumber } from '../../../utils/app.utils';
import { routeName } from '../../../routes/routeName';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { VisaFormApi } from '../../../api/visa-form/visa-form.api';
import { alertError, alertSuccess, swalError, swalSuccess } from '../../../components/alert/swal';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import AutocompleteSelect from '../../../components/select/autoCompleteSelect';
import StateComponents from '../../../components/state-component/StateComponents';
import { SubDistrictApi } from '../../../api/sub-district/sub-district.api';
import { DistrictApi } from '../../../api/district/district.api';
import { ProvinceAPI } from '../../../api/province/province.api';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { StudentApi } from '../../../api/student/student.api';
import { VisaRequestFrontApi } from '../../../api/visa-request-front/visa-request-front.api';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import moment from 'moment';
import InputTextField from '../../../components/input/inputTextField';
import CheckBoxCustom from '../../../components/checkbox/CheckBoxCustom';
import { CourseOfStudyApi } from '../../../api/course-of-study/course-of-study.api';
import ModalCustom from '../../../components/modal/ModalCustom';
import InfoIcon from '@mui/icons-material/Info';
import { ReactComponent as Bag } from '../../../assets/icons/bag-cross-red.svg'

export default function VisaRequestCreate(props: any) {
    const { view } = props
    const { t } = useTranslation();
    const { id } = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const [next, setNext] = useState<boolean>(false);
    const { profile } = useSelector((state: any) => state.profile);
    const [student, setStudent] = useState<any>({})
    const [visaForm, setVisaForm] = useState<any>({})
    const [showModal, setShowModal] = useState<string>("");

    const [form, setForm] = useState<any>({
        visa_form_name: ''
    });
    const [pathUrl, setPathUrl] = useState<any>(null);

    const [keyword, setKeyword] = useState<string>("");
    const [indexFile, setIndexFile] = useState<number>(0);

    const [dataDropdown, setDataDropdown] = useState<any[]>([]);
    const [files, setFiles] = useState<any[]>([]);
    const [filesVisa, setFilesVisa] = useState<any[]>([]);
    const [visaFormDocuments, setVisaFormDocuments] = useState<any[]>([]);
    const [errorMessage, setErrorMessage] = useState<any>()
    const clearErrorMessage = () => {
        setErrorMessage({})
    }
    // const getVisaType = async () => {
    //     const param = {
    //         page: 1,
    //         limit: 100
    //     }
    //     await VisaTypeApi.list(param).then((res) => {
    //         if (res.status < 300) {
    //             setVisaType(res.data?.data.items || []);
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //     })
    // }

    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results);
        };
        init();
    }, []);

    // const findById = async () => {

    //     await VisaFormApi.findById(id).then((res) => {
    //         if (res.status < 300) {
    //             setForm(res.data?.data);
    //             setFiles(res.data?.data?.visa_form_files)
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //     })
    // }

    // useEffect(() => {
    //     getVisaType()
    //     findById()
    // }, [])
    const handleGetData = useCallback(async () => {
        let query: any = {
            page: 1,
            limit: 10
        }
        if (keyword) query = { ...query, search: keyword }

        await VisaFormApi.dropdown(query).then((res) => {
            if (res.status < 300) {
                setDataDropdown(res.data?.data?.items || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [keyword])

    useEffect(() => {
        handleGetData()
    }, [handleGetData])

    const getStudent = async () => {
        const res = await StudentApi.getStudent(Number(profile?.id_student));
        const data = res.data;
        if (data.status < 300) {

            setStudent(res.data.data)
        }
    };
    const findById = async (id: number) => {

        await VisaFormApi.findById(id).then((res) => {
            if (res.status < 300) {
                // setForm(res.data?.data);
                setVisaForm(res.data?.data?.visa_type)
                setFilesVisa(res.data?.data?.visa_form_files)
                setVisaFormDocuments(res.data?.data?.visa_type?.visa_form_documents)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    useEffect(() => {
        if (profile?.id_student) {
            getStudent();
        }
    }, []);
    const handleSubmit = async (type?: any, tab?: any) => {
        // if (!form?.admission_student?.id_academic_year) {
        //     return alertError('Specify Academic Year')
        // }
        // if (!form?.admission_student?.id_degree) {
        //     return alertError('Specify Degree')
        // }
        // if (!form?.admission_student?.id_faculty) {
        //     return alertError('Specify Faculty')
        // }
        if (!form.province) {
           return setErrorMessage((prev: any) => ({ ...prev, province: "Specify Province" }))
        }
        if (!form.district) {
           return setErrorMessage((prev: any) => ({ ...prev, district: "Specify District " }))
        }
        if (!form.district_sub) {
          return  setErrorMessage((prev: any) => ({ ...prev, district_sub: "Specify State" }))
        }
        if (!form.post_code) {
           return setErrorMessage((prev: any) => ({ ...prev, postcode: "Specify Postal/Zip Code" }))
        }

        const body = {
            ...form,
            id_student: student?.id_student,
            student_no: student?.student_no,
            title: student?.title,
            student_frist_name: student?.student_frist_name,
            student_middle_name: student?.student_middle_name,
            nationality: student?.nationality,
            id_course_of_study: student?.id_course_of_study,
            id_degree: student?.id_degree,
            id_faculty: student?.id_faculty,
            student_email: student?.student_email,
        }
        dispatch(setLoading());

        await VisaRequestFrontApi.post(body)
            .then(async (res) => {
                if (res.status < 300) {
                    if (visaFormDocuments?.filter((x) => x?.visa_request_documents)?.length > 0) {
                        const formData = new FormData();

                        visaFormDocuments?.filter((x) => x?.visa_request_documents).forEach((file) => {
                             for (const element of file.visa_request_documents) {
                                formData.append("files", element);
                                formData.append("id_visa_form_document", file.id_visa_form_document);
                                formData.append("id_visa_step", file.id_visa_step);
                                formData.append("document_name", file.document_name);
                                formData.append("document_type", file.document_type);

                            }
                        });

                        await VisaRequestFrontApi.file(res.data.data.id_visa_request, formData)
                            .then((resp) => {
                                if (resp.status < 300) {
                                    alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.visa_request_detail.replace(':id', res.data.data.id_visa_request)));
                                }
                            })
                    } else {
                        alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.visa_request_detail.replace(':id', res.data.data.id_visa_request)));

                    }


                }
            })

            .finally(() => {
                dispatch(unsetLoading());
            });

    }
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("สร้างรายการส่งคำร้อง")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("ระบบคำร้อง"),
                                disabled_match: true,
                                pathName: routeName.request_form.visa_request
                            },
                            {
                                key: "complaintSubmit",
                                name: t("ส่งคำร้อง"),
                                pathName: routeName.request_form.visa_request
                            },
                            {
                                key: "complaintSubmit",
                                name: t("สร้างรายการส่งคำร้อง"),
                                pathName: routeName.request_form.visa_request_create
                            },
                        ]}
                    />
                }
                buttonContent={

                    <ContainerButton
                        // sxContainer={{ my: 3 }}
                        justifyContent='flex-end'
                        buttonData={[
                            {
                                seq: 1,
                                buttonProps: {
                                    onClick: () => { navigate(-1) },
                                },
                                key: "CANCEL",
                                label: t("LIST_APPLICANTS_BACK"),
                                type: "CANCEL"
                            },
                            {
                                seq: 2,
                                buttonProps: {
                                    onClick: () => {
                                        //   setShowModal('REJECT')
                                        handleSubmit()
                                    },
                                    disabled: !next
                                },
                                key: "SAVE_DRAFT",
                                label: t("บันทึกร่าง"),
                                type: 'SAVE_DRAFT'
                            },

                        ]}
                    />
                }
                content={
                    <>
                        {next && <Box sx={{ display: "flex", gap: '5px', alignItems: 'center' }}>
                            <IconButton onClick={() => setShowModal('SHOW')}><InfoIcon />
                            </IconButton><Typography>ข้อมูล</Typography>
                        </Box>}
                        {
                            next ? <RequestFormCreate view={view} form={form} setForm={setForm} student={student} setStudent={setStudent} getVisaForm={findById} visaForm={visaForm} visaFormDocuments={visaFormDocuments} setVisaFormDocuments={setVisaFormDocuments} errorMessage={errorMessage} clearErrorMessage={clearErrorMessage} /> :
                                <div style={{ maxWidth: "1000px", margin: '0px auto' }}>
                                    <AutocompleteSelect
                                        heading={'General Request For'} placeholder={'ค้นหา General Request For'}
                                        freeSolo
                                        labelId={''} options={dataDropdown}
                                        getOptionLabel={(option: any) => option?.visa_form_name || ''}
                                        onChange={(e: any, val: any) => {
                                            // setForm(value)
                                            setForm({ ...form, id_visa_form: val?.id_visa_form, visa_form_name: val?.visa_form_name })
                                            findById(val?.id_visa_form)

                                        }}
                                        inputValue={keyword || ''}
                                        onInputChange={(e: any, value: any) => {
                                            // setKeyword(e.target.value)
                                            debouncedApiCall({ setItem: setKeyword, searchItem: value })
                                        }}
                                        value={form || null}
                                    />
                                    {form?.id_visa_form && <>
                                        <Typography sx={{ fontSize: "24px", fontWeight: "600", margin: '40px 0px' }}>IBSC General Request Form</Typography>

                                        <Box sx={{ padding: '40px', borderBottom: '8px solid #2186E3', boxShadow: '0px 0px 10px 0px #00000026', borderRadius: '16px', marginBottom: "20px", }}>
                                            <Box sx={{ display: 'flex', flexDirection: "column", gap: '10px', padding: "0px 100px" }}>
                                                <Typography sx={{ fontSize: "18px", fontWeight: "600", margin: '20px 0px', textAlign: 'center' }}>Guideline for Requesting a Certification of Student</Typography>
                                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: "15px" }}>
                                                    {filesVisa?.map((_, i) => {
                                                        return (
                                                            <Avatar sx={{ width: 24, height: 24, background: indexFile === i ? '#FCAF17' : "#F2F4F7", color: indexFile === i ? '#fff' : "#000" }} onClick={() => setIndexFile(i)}>{i + 1}</Avatar>
                                                        )
                                                    })}
                                                </Box>
                                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    {filesVisa?.filter((_, i) => i === indexFile)?.map((item: any) => {
                                                        return (
                                                            <img src={`${pathUrl?.REACT_APP_BASE_API_PUBLIC}/${item?.file_path}${item?.file_name}`} style={{
                                                                maxWidth: '100%',
                                                                height: '500px',
                                                                objectFit: "contain",
                                                                objectPosition: 'center'
                                                            }} />
                                                        )
                                                    })}
                                                </Box>
                                                <ContainerButton
                                                    sxContainer={{ mt: 3 }}
                                                    justifyContent='space-between'
                                                    buttonData={[
                                                        {
                                                            seq: 1,
                                                            buttonProps: {
                                                                onClick: () => { navigate(-1) },
                                                            },
                                                            key: "CANCEL",
                                                            label: t("LIST_APPLICANTS_BACK"),
                                                            type: "CANCEL"
                                                        },
                                                        // {
                                                        //     seq: 2,
                                                        //     buttonProps: {
                                                        //         onClick: () => {
                                                        //             //   setShowModal('REJECT')
                                                        //             handleSubmit()
                                                        //         }
                                                        //     },
                                                        //     key: "SAVE_DRAFT",
                                                        //     label: t("บันทึกร่าง"),
                                                        //     type: 'SAVE_DRAFT'
                                                        // },
                                                        {
                                                            seq: 2,
                                                            hidden: view,
                                                            buttonProps: {
                                                                onClick: () => {

                                                                    setNext(true)
                                                                }
                                                            },
                                                            key: "NEXT",
                                                            label: t("ถัดไป"),
                                                            type: 'NEXT'
                                                        },
                                                    ]}
                                                />
                                            </Box>

                                        </Box>
                                    </>}

                                </div>
                        }
                    </>

                }
            />

            {showModal !== '' && (
                <ModalCustom
                    open
                    title={'IBSC General Request Form'}
                    subTitle={t("Guideline for Requesting a Certification of Student")}
                    onClose={() => setShowModal('')}

                    containerButton={{
                        onClose: () => setShowModal(''),
                        hidden_submit: true
                    }}
                    component={
                        <div className='w-full'>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: "15px" }}>
                                {filesVisa?.map((_, i) => {
                                    return (
                                        <Avatar sx={{ width: 24, height: 24, background: indexFile === i ? '#FCAF17' : "#F2F4F7", color: indexFile === i ? '#fff' : "#000" }} onClick={() => setIndexFile(i)}>{i + 1}</Avatar>
                                    )
                                })}
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {filesVisa?.filter((_, i) => i === indexFile)?.map((item: any) => {
                                    return (
                                        <img src={`${pathUrl?.REACT_APP_BASE_API_PUBLIC}/${item?.file_path}${item?.file_name}`} style={{
                                            maxWidth: '100%',
                                            height: '500px',
                                            objectFit: "contain",
                                            objectPosition: 'center'
                                        }} />
                                    )
                                })}
                            </Box>

                        </div>
                    }
                />
            )}
        </div >
    )
}

export function RequestFormCreate(props: any) {
    const { view, form, setForm, student, setStudent, getVisaForm, visaForm, visaFormDocuments, setVisaFormDocuments, errorMessage, clearErrorMessage } = props
    const { t } = useTranslation();
    const { id } = useParams()
    const dispatch = useDispatch();


    const navigate = useNavigate()
    const [pathUrl, setPathUrl] = useState<any>(null);

    // const [form, setForm] = useState<any>({})
    const [province_data, setProVinceData] = useState<any[]>([]);
    const [district_data, setDistrictData] = useState<any[]>([]);
    const [sub_district_data, setSubDistrictData] = useState<any[]>([]);
    const [keyword, setKeyword] = useState<string>("");
    const [academicYear, setAcademicYear] = useState<any[]>([])

    const [dataDropdown, setDataDropdown] = useState<any[]>([]);
    const [courseAnnual, setCourseAnnual] = useState<any[]>([]);
    const [courseAnnualById, setCourseAnnualById] = useState<any[]>([]);

    const handleGetCourseAnnual = useCallback(async () => {
        let query: any = {
            page: 1,
            limit: 100
        }
        // if (keyword) query = { ...query, search: keyword }

        await VisaRequestFrontApi.course_annual(query).then((res) => {
            if (res.status < 300) {
                setCourseAnnual(res.data?.data?.items || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [])
    const handleGetCourseAnnualById = useCallback(async (id: any) => {
        let query: any = {
            page: 1,
            limit: 100
        }
        // if (keyword) query = { ...query, search: keyword }

        await VisaRequestFrontApi.course_annual_id(id, query).then((res) => {
            if (res.status < 300) {
                setCourseAnnualById(res.data?.data?.items || []);

            }
        }).catch((err) => {
            console.log(err)
        })
    }, [])

    useEffect(() => {
        if (form?.id_course_annual) {
            handleGetCourseAnnualById(form?.id_course_annual)
        }
    }, [form?.id_course_annual])
    const handleGetData = useCallback(async () => {
        let query: any = {
            page: 1,
            limit: 10
        }
        if (keyword) query = { ...query, search: keyword }

        await VisaFormApi.dropdown(query).then((res) => {
            if (res.status < 300) {
                setDataDropdown(res.data?.data?.items || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [keyword])

    useEffect(() => {
        handleGetData()
    }, [handleGetData])

    const handleGetProvince = async () => {
        await ProvinceAPI.GetProvince().then(res => {
            if (res.status < 300) {
                setProVinceData(res.data?.data || [])
            } else {
                setProVinceData([]);
            }
        }).catch((error) => console.log(error))
    }
    const handleGetDistrict = async (id?: any) => {
        if (id) {
            await DistrictApi.getDistrictByProvince(id).then(res => {
                if (res.status < 300) {
                    setDistrictData(res.data?.data || [])
                } else {
                    setDistrictData([]);
                }
            }).catch((error) => console.log(error))
        } else {
            // await DistrictApi.getAllDistrict().then(res => {
            //     if (res.status < 300) {
            //         setDistrictData(res.data?.data || [])
            //     } else {
            //         setDistrictData([]);
            //     }
            // }).catch((error) => console.log(error))
        }

    }
    const handleGetSubDistrict = async (id?: any) => {
        if (id) {
            await SubDistrictApi.getSubDistrictByDistrict(id).then(res => {
                if (res.status < 300) {
                    setSubDistrictData(res.data?.data || [])
                } else {
                    setSubDistrictData([]);
                }
            }).catch((error) => console.log(error))
        } else {
            // await SubDistrictApi.getAllSubDistrict().then(res => {
            //     if (res.status < 300) {
            //         setSubDistrictData(res.data?.data || [])
            //     } else {
            //         setSubDistrictData([]);
            //     }
            // }).catch((error) => console.log(error))
        }

    }


    const getAcademicYear = async () => {
        await CourseOfStudyApi.academicDataDropdown().then((res) => {
            if (res.status < 300) {
                const uniqueAcademicYears = res.data.data.reduce((acc: any[], curr: any) => {
                    if (!acc.some(item => item.academic_year === curr.academic_year)) {
                        acc.push({
                            id_academic_year: curr.id_academic_year, // ถ้า null ให้เป็น 5
                            academic_year: curr.academic_year,
                        });
                    }
                    return acc;
                }, []);

                setAcademicYear(uniqueAcademicYears || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        handleGetProvince()
        handleGetDistrict()
        handleGetSubDistrict()
        handleGetCourseAnnual()
        getAcademicYear()

    }, [])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={9}>
                <StateComponents
                    otherProps={{ spacing: 2 }}
                    typeProps={[
                        {
                            seq: 1,
                            type: "AUTO-COMPLETE",
                            gridProps: {
                                xs: 12
                            },
                            fieldProps: {
                                getOptionLabel: (op) => op?.visa_form_name,
                                labelId: "bank",
                                heading: "General Request For",
                                placeholder: "ระบุ",
                                onChange: (_, val) => {
                                    setForm({ ...form, id_visa_form: val?.id_visa_form, visa_form_name: val?.visa_form_name })
                                    getVisaForm(val?.id_visa_form)
                                },
                                // onInputChange: (e: any) =>  setKeyword(e?.target?.value),
                                options: dataDropdown,
                                // inputValue: keyword,
                                value: form || null,
                                disabled: view
                            }
                        },
                        {
                            seq: 2,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: t("Student ID"),
                                value: student?.student_no || '',
                                onChange: (e) => {
                                    // setForm({ ...form, student_no: e.target.value })
                                },
                                disabled: true
                            }
                        },
                        {
                            seq: 3,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: t("Title"),
                                value: student?.title || '',
                                onChange: (e) => {
                                    // setForm({ ...form, title: e.target.value })
                                },
                                disabled: true
                            }
                        },
                        {
                            seq: 4,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: t("Name-Surname/Buddhist Name"),
                                value: `${student?.student_frist_name} ${student?.student_last_name || ''} ${student?.student_middle_name}` || '',
                                onChange: (e) => {
                                    // setForm({ ...form, student_frist_name: e.target.value })
                                },
                                disabled: true
                            }
                        },
                        {
                            seq: 5,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            fieldProps: {
                                heading: t("Nationality"),
                                value: student?.nationality || '',
                                onChange: (e) => {
                                    // setForm({ ...form, nationality: e.target.value })
                                },
                                disabled: true
                            }
                        },
                        {
                            seq: 6,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            fieldProps: {
                                heading: t("Program"),
                                value: student?.faculty?.faculty_name ? `${student?.faculty?.faculty_name_eng} (${student?.faculty?.faculty_name})` : '',
                                onChange: (e) => {
                                    // setForm({ ...form, visa_form_name: e.target.value })
                                },
                                disabled: true
                            }
                        },
                        {
                            seq: 7,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: t("Email"),
                                value: student?.student_email || '',
                                onChange: (e) => {
                                    // setForm({ ...form, student_email: e.target.value })
                                },
                                disabled: true
                            }
                        },
                        {
                            seq: 8,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: t("Phone Number"),
                                value: form?.phone || '',
                                onChange: (e) => {
                                    setForm({ ...form, phone: e.target.value })
                                },
                                disabled: view
                            }
                        },
                        {
                            seq: 9,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: t("LINE ID"),
                                value: form?.line || '',
                                onChange: (e) => {
                                    setForm({ ...form, line: e.target.value })
                                },
                                disabled: view
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 10,
                            hidden: ![1, 3].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <Typography sx={{ fontSize: '18px', fontWeight: '600' }}>Address</Typography>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 11,
                            hidden: ![1, 3].includes(visaForm?.id_visa_type),

                            fieldProps: {
                                element: <>
                                    <Typography sx={{ fontWeight: '600' }}>Accommodation Type</Typography>
                                    <RadioGroup
                                        row
                                        value={form?.accommodation_type || ''}
                                        onChange={(e) => {
                                            setForm({ ...form, accommodation_type: e.target.value })
                                        }}
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="ON" disabled={view} control={<Radio />} label="On-campus dormitory" />
                                        <FormControlLabel value="OFF" disabled={view} control={<Radio />} label="Off-campus housing" />
                                    </RadioGroup>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },

                        {
                            seq: 12,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "House No.",
                                onChange: (e) => {
                                    setForm({ ...form, house: e.target.value })
                                },
                                value: form?.house,
                                disabled: view
                            }
                        },
                        {
                            seq: 13,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Street / Road",
                                onChange: (e) => {
                                    setForm({ ...form, street: e.target.value })
                                },
                                value: form?.street,
                                disabled: view
                            }
                        },
                        {
                            seq: 14,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Village",
                                onChange: (e) => {
                                    setForm({ ...form, village: e.target.value })
                                },
                                value: form?.village,
                                disabled: view
                            }
                        },
                        {
                            seq: 15,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Town / City",
                                onChange: (e) => {
                                    setForm({ ...form, town: e.target.value })
                                },
                                value: form?.town,
                                disabled: view
                            }
                        },

                        {
                            seq: 16,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Province",
                                onChange: (e) => {
                                    clearErrorMessage()
                                    setForm({ ...form, province: e.target.value })
                                },
                                value: form?.province || '',
                                disabled: view,
                                required: true,
                                helperText: errorMessage?.province || ''
                            }
                            // type: "AUTO-COMPLETE",
                            // gridProps: {
                            //     xs: 12,
                            //     md: 4
                            // },
                            // fieldProps: {
                            //     getOptionLabel: (op: any) => op?.province_name,
                            //     labelId: "select_position",
                            //     placeholder: "Province",
                            //     heading: "Province",
                            //     onChange: (_: any, value: any) => {

                            //         if (value) {
                            //             // setForm({ ...form, province: value?.province_name })
                            //             setForm({ ...form, province: value?.province_name, district: '' })

                            //             handleGetDistrict(value?.id_province)

                            //         } else {
                            //             // setForm({ ...form, province: undefined })
                            //             setForm({ ...form, province: '', district: '' })

                            //             setDistrictData([])
                            //         }
                            //     },
                            //     options: province_data || [],
                            //     value: province_data?.find((x) => x?.province_name === form?.province) || null,
                            //     disabled: view
                            // }
                        },
                        {
                            seq: 17,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "District",
                                onChange: (e) => {
                                    clearErrorMessage()
                                    setForm({ ...form, district: e.target.value })
                                },
                                value: form?.district || '',
                                disabled: view,
                                required: true,
                                helperText: errorMessage?.district || ''
                            }
                            // type: "AUTO-COMPLETE",
                            // gridProps: {
                            //     xs: 12,
                            //     md: 4
                            // },
                            // fieldProps: {
                            //     getOptionLabel: (op: any) => op?.district_name,
                            //     labelId: "select_position",
                            //     placeholder: "District",
                            //     heading: "District",
                            //     onChange: (_: any, value: any) => {

                            //         if (value) {
                            //             // setForm({ ...form, district: value?.district_name })
                            //             setForm({ ...form, district: value?.district_name, district_sub: '' })

                            //             handleGetSubDistrict(value?.id_district)

                            //         } else {
                            //             // setForm({ ...form, district: undefined })
                            //             setForm({ ...form, district: '', district_sub: '' })

                            //             setSubDistrictData([])
                            //         }
                            //     },
                            //     options: district_data || [],
                            //     value: district_data?.find((x) => x?.district_name === form?.district) || null,
                            //     inputValue: form?.district || '',
                            //     disabled: view
                            // }
                        },
                        {
                            seq: 18,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "State",
                                onChange: (e) => {
                                    clearErrorMessage()
                                    setForm({ ...form, district_sub: e.target.value })
                                },
                                value: form?.district_sub || '',
                                disabled: view,
                                required: true,
                                helperText: errorMessage?.district_sub || ''
                            }
                            // type: "AUTO-COMPLETE",
                            // gridProps: {
                            //     xs: 12,
                            //     md: 4
                            // },
                            // fieldProps: {
                            //     getOptionLabel: (op: any) => op?.district_sub_name,
                            //     labelId: "select_position",
                            //     placeholder: "State",
                            //     heading: "State",
                            //     onChange: (_: any, value: any) => {

                            //         if (value) {
                            //             console.log(value);
                            //             // setForm({ ...form, district_sub: value?.sub_district_name })
                            //             setForm({ ...form, district_sub: value?.district_sub_name })


                            //         } else {
                            //             // setForm({ ...form, district_sub: undefined })
                            //             setForm({ ...form, district_sub: '' })

                            //         }
                            //     },
                            //     options: sub_district_data || [],
                            //     value: sub_district_data?.find((x) => x?.sub_district_name === form?.district_sub) || null,
                            //     inputValue: form?.district_sub || '',
                            //     disabled: view

                            // }
                        },

                        {
                            seq: 19,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Country",
                                onChange: (e) => {
                                    setForm({ ...form, country: e.target.value })
                                },
                                value: form?.country,
                                disabled: view
                            }
                        },
                        {
                            seq: 20,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Postal/Zip Code",
                                onChange: (e) => {
                                    clearErrorMessage()
                                    setForm({ ...form, post_code: e.target.value })
                                },
                                value: form?.post_code || '',
                                onkeypress: handleTypingNumber,
                                disabled: view,
                                required: true,
                                helperText: errorMessage?.post_code || ''
                            }
                        },
                        {
                            seq: 21,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            fieldProps: {
                                heading: "Holding Passport No.",
                                onChange: (e) => {
                                    setForm({ ...form, holding_passport_no: e.target.value })
                                },
                                value: form?.holding_passport_no,
                                disabled: view
                                // onkeypress: handleTypingNumber
                            }
                        },
                        {
                            seq: 21.1,
                            type: "TEXT_FIELD",
                            hidden: ![4].includes(visaForm?.id_visa_type),
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Building",
                                onChange: (e) => {
                                    setForm({ ...form, building: e.target.value })
                                },
                                value: form?.building,
                                disabled: view
                                // onkeypress: handleTypingNumber
                            }
                        },
                        {
                            seq: 21.2,
                            type: "TEXT_FIELD",
                            hidden: ![4].includes(visaForm?.id_visa_type),
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Floor",
                                onChange: (e) => {
                                    setForm({ ...form, floor: e.target.value })
                                },
                                value: form?.floor,
                                onkeypress: handleTypingNumber,
                                disabled: view
                            }
                        },
                        {
                            seq: 21.3,
                            type: "TEXT_FIELD",
                            hidden: ![4].includes(visaForm?.id_visa_type),
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Room",
                                onChange: (e) => {
                                    setForm({ ...form, room: e.target.value })
                                },
                                value: form?.room,
                                onkeypress: handleTypingNumber,
                                disabled: view
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 21.4,
                            hidden: ![4].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Typography>Student Status</Typography>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        onChange={(e) => {
                                            setForm({ ...form, student_type: e.target.value })
                                        }}
                                        value={form?.student_type || ''}
                                    >
                                        <FormControlLabel value={'NEW'} disabled={view} control={<Radio />} label="new student" />
                                        <FormControlLabel value={'OLD'} disabled={view} control={<Radio />} label="old student" />
                                    </RadioGroup>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            seq: 22,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            hidden: ![6, 7, 13].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                heading: "Name of Meditation Practice Institute",
                                onChange: (e) => {
                                    setForm({ ...form, name_meditation_practice_institute: e.target.value })
                                },
                                value: form?.name_meditation_practice_institute,
                                disabled: view
                                // onkeypress: handleTypingNumber
                            }
                        },
                        {
                            seq: 22.1,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            hidden: ![6, 7, 13].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                heading: "Name of Director's institute",
                                onChange: (e) => {
                                    setForm({ ...form, name_directors_institute: e.target.value })
                                },
                                value: form?.name_directors_institute,
                                disabled: view
                                // onkeypress: handleTypingNumber
                            }
                        },
                        {
                            seq: 22.2,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            hidden: ![6, 7, 13].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                heading: "Address of Meditation Practice Institute",
                                onChange: (e) => {
                                    setForm({ ...form, address_meditation_practice_institute: e.target.value })
                                },
                                value: form?.address_meditation_practice_institute,
                                disabled: view
                                // onkeypress: handleTypingNumber
                            }
                        },

                        {
                            seq: 23.1,
                            type: "AUTO-COMPLETE",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            hidden: ![16].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                getOptionLabel: (op: any) => op?.courses_no,
                                labelId: "select_position",
                                placeholder: "Subject id",
                                heading: "Subject id",
                                onChange: (_: any, value: any) => {

                                    if (value) {
                                        // setForm({ ...form, province: value?.province_name })
                                        setForm({ ...form, id_course: value?.id_courses, course_no: value?.courses_no, id_employee: '', employee_name: '', id_course_annual: value?.id_course_annual })
                                        handleGetCourseAnnualById(value?.id_course_annual)

                                    } else {
                                        // setForm({ ...form, province: undefined })
                                        setForm({ ...form, id_course: '', course_no: '', id_employee: '', employee_name: '', id_course_annual: '' })

                                    }
                                },
                                options: courseAnnual || [],
                                value: courseAnnual?.find((x) => x?.id_courses === form?.id_course) || null,
                                disabled: view
                            }
                        },
                        {
                            seq: 23.2,
                            type: "AUTO-COMPLETE",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            hidden: ![16].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                getOptionLabel: (op: any) => op?.courses_name,
                                labelId: "select_position",
                                placeholder: "Subject",
                                heading: "Subject",
                                onChange: (_: any, value: any) => {

                                    if (value) {
                                        // setForm({ ...form, province: value?.province_name })
                                        setForm({ ...form, id_course: value?.id_courses, course_no: value?.courses_no, id_employee: '', employee_name: '' })
                                        handleGetCourseAnnualById(value?.id_course_annual)

                                    } else {
                                        // setForm({ ...form, province: undefined })
                                        setForm({ ...form, id_course: '', course_no: '', id_employee: '', employee_name: '' })

                                    }
                                },
                                options: courseAnnual || [],
                                value: courseAnnual?.find((x) => x?.id_courses === form?.id_course) || null,
                                disabled: view
                            }
                        },
                        {
                            seq: 23.3,
                            type: "AUTO-COMPLETE",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            hidden: ![16].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                getOptionLabel: (op: any) => op?.employee_name,
                                labelId: "select_position",
                                placeholder: "Lecturer",
                                heading: "Lecturer",
                                onChange: (_: any, value: any) => {

                                    if (value) {
                                        // setForm({ ...form, province: value?.province_name })
                                        setForm({ ...form, id_employee: value?.id_employee, employee_name: value?.employee_name })


                                    } else {
                                        // setForm({ ...form, province: undefined })
                                        setForm({ ...form, id_employee: '', employee_name: '' })

                                    }
                                },
                                options: courseAnnualById || [],
                                value: courseAnnualById?.find((x) => x?.id_employee === form?.id_employee) || null,
                                disabled: view
                            }
                        },
                        {
                            seq: 23.4,
                            type: "DATE",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            hidden: ![16].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                onChange: (e) => {
                                    setForm({ ...form, start_date: moment(e).format('YYYY-MM-DD') })
                                },
                                heading: 'Start Date',
                                placeholder: 'Start Date',
                                allowClear: true,
                                onClear: () => {
                                    setForm({ ...form, start_date: '' })
                                },
                                value: form?.start_date,
                                disabled: view
                            }

                        },
                        {
                            seq: 23.5,
                            type: "DATE",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            hidden: ![16].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                onChange: (e) => {
                                    setForm({ ...form, end_date: moment(e).format('YYYY-MM-DD') })
                                },
                                heading: 'End Date',
                                placeholder: 'End Date',
                                allowClear: true,
                                onClear: () => {
                                    setForm({ ...form, end_date: '' })
                                },
                                value: form?.end_date,
                                disabled: view
                            }

                        },
                        {
                            seq: 23.6,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            hidden: ![16, 17].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                heading: "Reason",
                                onChange: (e) => {
                                    setForm({ ...form, reason: e.target.value })
                                },
                                value: form?.reason,
                                // onkeypress: handleTypingNumber,
                                multiline: true,
                                minRow: 6,
                                inputHeight: 'auto',
                                disabled: view
                            }
                        },
                        {
                            seq: 23.7,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            hidden: ![19].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                heading: "Descriptions",
                                onChange: (e) => {
                                    setForm({ ...form, descriptions: e.target.value })
                                },
                                value: form?.descriptions,
                                // onkeypress: handleTypingNumber,
                                multiline: true,
                                minRow: 6,
                                inputHeight: 'auto',
                                disabled: view
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 24,
                            hidden: ![10, 9, 8].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Box sx={{ display: "flex", gap: "10px", alignItems: "center", cursor: "pointer" }} onClick={() => {
                                        if (!view) {
                                            setForm({
                                                ...form, visa_request_interviewers: form.visa_request_interviewers?.length > 0 ? [
                                                    ...form.visa_request_interviewers, { name_interviewer: '', address_interviewer: '' }
                                                ] : [{ name_interviewer: '', address_interviewer: '' }]
                                            })
                                        }

                                    }} >

                                        {!view && <AddBoxIcon sx={{ color: '#5FB95D', }} />}
                                        <Typography sx={{ fontSize: "18px", fontWeight: '600' }}>Interviewer</Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        {form?.visa_request_interviewers?.map((item: any, index: number) => {
                                            return (
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} md={5}><InputTextField heading='Name of Interviewer' disabled={view} value={item?.name_interviewer} onChange={(e) => {
                                                        setForm({
                                                            ...form, visa_request_interviewers: form.visa_request_interviewers.map((x: any, i: number) => {
                                                                return i === index
                                                                    ? {
                                                                        ...x,
                                                                        name_interviewer: e.target.value
                                                                    }
                                                                    : x
                                                            })
                                                        })
                                                    }} /></Grid>
                                                    <Grid item xs={11} md={6}><InputTextField heading='Address of Interviewer' disabled={view} value={item?.address_interviewer} onChange={(e) => {
                                                        setForm({
                                                            ...form, visa_request_interviewers: form.visa_request_interviewers.map((x: any, i: number) => {
                                                                return i === index
                                                                    ? {
                                                                        ...x,
                                                                        address_interviewer: e.target.value
                                                                    }
                                                                    : x
                                                            })
                                                        })
                                                    }} /></Grid>
                                                    <Grid item xs={1} md={1} sx={{ display: 'flex', alignItems: "end" }}>
                                                        {!view && <Box onClick={() => {
                                                            setForm({
                                                                ...form, visa_request_interviewers: form.visa_request_interviewers.filter((_: any, i: number) => i !== index)
                                                            })
                                                        }}><Bag /></Box>}
                                                    </Grid>
                                                </Grid>
                                            )
                                        })}
                                    </Box>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 25,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Box sx={{ border: '2px dashed #DDE1EB', width: "100%" }}></Box>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 25.1,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Typography>Research Topic</Typography>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        onChange={(e) => {
                                            setForm({ ...form, research_topic: e.target.value })
                                        }}
                                        value={form?.research_topic || ''}
                                    >
                                        <FormControlLabel value={'DISSERTATION'} disabled={view} control={<Radio />} label="Dissertation" />
                                        <FormControlLabel value={'THESIS'} disabled={view} control={<Radio />} label="Thesis" />
                                        <FormControlLabel value={'INDEPENDENT_STUDY'} disabled={view} control={<Radio />} label="Independent Study" />
                                    </RadioGroup>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            seq: 25.2,
                            type: "TEXT_FIELD",
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            gridProps: {
                                xs: 12,
                            },
                            // hidden: ![19].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                heading: "Research Title",
                                onChange: (e) => {
                                    setForm({ ...form, research_title: e.target.value })
                                },
                                value: form?.research_title,
                                // onkeypress: handleTypingNumber,
                                multiline: true,
                                minRow: 6,
                                inputHeight: 'auto',
                                disabled: view

                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 25.3,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Box sx={{ border: '2px dashed #DDE1EB', width: "100%" }}></Box>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 25.4,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Typography>Attached topics and outlines</Typography>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        onChange={(e) => {
                                            setForm({ ...form, attached_topice: e.target.value })
                                        }}
                                        value={form?.attached_topice || ''}
                                    >
                                        <FormControlLabel value={'THESIS'} disabled={view} control={<Radio />} label="Thesis" />
                                        <FormControlLabel value={'INDEPENDENT_STUDY'} disabled={view} control={<Radio />} label="Independent Study" />
                                        <FormControlLabel value={'ACADEMIC_ARTICLE'} disabled={view} control={<Radio />} label="Academic Article" />
                                        <FormControlLabel value={'BOOK_REVIEW'} disabled={view} control={<Radio />} label="Book Review" />
                                    </RadioGroup>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            seq: 25.5,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                heading: "Quantity (sets)",
                                onChange: (e) => {
                                    setForm({ ...form, quantity: e.target.value })
                                },
                                value: form?.quantity,
                                onkeypress: handleTypingNumber,
                                disabled: view
                                // multiline: true,
                                // minRow: 6,
                                // inputHeight: 'auto'
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 25.6,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Typography>For the purpose of</Typography>
                                    <RadioGroup

                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        onChange={(e) => {
                                            setForm({ ...form, for_the_purpose_of: e.target.value })
                                        }}
                                        value={form?.for_the_purpose_of || ''}
                                    >
                                        <FormControlLabel value={'APPROVAL_FOR_THESIS'} disabled={view} control={<Radio />} label="Requesting approval for thesis/dissertation title and proposal examination" />
                                        <FormControlLabel value={'CONSIDERATION'} disabled={view} control={<Radio />} label="Requesting consideration and approval of the thesis/dissertation title and proposal" />
                                        <FormControlLabel value={'APPROVAL_FOR_ACADEMIC'} disabled={view} control={<Radio />} label="Requesting approval for academic article evaluation" />
                                        <FormControlLabel value={'APPROVAL_FOR_BOOK'} disabled={view} control={<Radio />} label="Requesting approval for book review evaluation" />
                                    </RadioGroup>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 25.7,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Box sx={{ border: '2px dashed #DDE1EB', width: "100%" }}></Box>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 25.8,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Typography>Request to Change Title and/or Research Proposal</Typography>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        onChange={(e) => {
                                            setForm({ ...form, request_to_change: e.target.value })
                                        }}
                                        value={form?.request_to_change || ''}
                                    >
                                        <FormControlLabel value={'DISSERTATION'} disabled={view} control={<Radio />} label="Dissertation" />
                                        <FormControlLabel value={'THESIS'} disabled={view} control={<Radio />} label="Thesis" />
                                        <FormControlLabel value={'INDEPENDENT_STUDY'} disabled={view} control={<Radio />} label="Independent Study" />
                                    </RadioGroup>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            seq: 25.9,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                heading: "Reason for Change",
                                onChange: (e) => {
                                    setForm({ ...form, request_to_change_reason_for_change: e.target.value })
                                },
                                value: form?.request_to_change_reason_for_change,
                                // onkeypress: handleTypingNumber,
                                multiline: true,
                                minRow: 6,
                                inputHeight: 'auto',
                                disabled: view
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 26,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Box sx={{ border: '2px dashed #DDE1EB', width: "100%" }}></Box>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 26.1,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <Box sx={{ display: 'flex', flexDirection: "column" }}>
                                    <Typography>I wish to request a modification</Typography>
                                    <FormControlLabel control={<Checkbox checked={form?.wish_request_title || ''} onChange={(e) =>
                                        setForm({ ...form, wish_request_title: e.target.checked })
                                    } disabled={view} />} label='Thesis/Independent Study Title' />
                                    <FormControlLabel control={<Checkbox checked={form?.wish_request_proposal || ''} onChange={(e) =>
                                        setForm({ ...form, wish_request_proposal: e.target.checked })
                                    } disabled={view} />} label='Thesis/Independent Study Proposal or Significant SectionThesis/Independent Study Proposal or Significant Section' />
                                    <FormControlLabel control={<Checkbox checked={form?.wish_request_advisor || ''} onChange={(e) =>
                                        setForm({ ...form, wish_request_advisor: e.target.checked })
                                    } disabled={view} />} label='Thesis/Independent Study Advisor/Supervisor' />
                                    <FormControlLabel control={<Checkbox checked={form?.wish_request_other || ''} onChange={(e) =>
                                        setForm({ ...form, wish_request_other: e.target.checked, wish_request_other_desc: '' })
                                    } disabled={view} />} label={<Box sx={{ display: "flex", gap: '10px', alignItems: "center" }}><Typography sx={{ textWrap: "nowrap" }}>Other (Specify):</Typography><InputTextField disabled={view || !form?.wish_request_other} value={form?.wish_request_other_desc || ''} onChange={(e) =>
                                        setForm({ ...form, wish_request_other_desc: e.target.value })
                                    } /></Box>} />
                                </Box>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            seq: 26.2,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                heading: "From",
                                onChange: (e) => {
                                    setForm({ ...form, wish_request_from: e.target.value })
                                },
                                value: form?.wish_request_from,
                                disabled: view
                                // onkeypress: handleTypingNumber,
                                // multiline: true,
                                // minRow: 6,
                                // inputHeight: 'auto'
                            }
                        },
                        {
                            seq: 26.3,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                heading: "Change to",
                                onChange: (e) => {
                                    setForm({ ...form, wish_request_change: e.target.value })
                                },
                                value: form?.wish_request_change,
                                disabled: view
                                // onkeypress: handleTypingNumber,
                                // multiline: true,
                                // minRow: 6,
                                // inputHeight: 'auto'
                            }
                        },
                        {
                            seq: 26.4,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                heading: "Reason for the change",
                                onChange: (e) => {
                                    setForm({ ...form, reason_for_change: e.target.value })
                                },
                                value: form?.reason_for_change,
                                disabled: view
                                // onkeypress: handleTypingNumber,
                                // multiline: true,
                                // minRow: 6,
                                // inputHeight: 'auto'
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 26.5,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Box sx={{ border: '2px dashed #DDE1EB', width: "100%" }}></Box>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 26.6,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Typography>I request to</Typography>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        onChange={(e) => {
                                            setForm({ ...form, request_to: e.target.value })
                                        }}
                                        value={form?.request_to || ''}
                                    >
                                        <FormControlLabel value={'DEFEND_MY_THESIS'} disabled={view} control={<Radio />} label="Defend my thesis" />
                                        <FormControlLabel value={'DEFEND_MY_INDEPENDENT'} disabled={view} control={<Radio />} label="Defend my independent study after completion" />
                                        <FormControlLabel value={'PRESENT_MY_THESIS'} disabled={view} control={<Radio />} label="Present my thesis at a Public Hearing" />
                                    </RadioGroup>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 26.7,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Typography sx={{ color: '#DDE1EB', fontSize: "14px" }}>I have followed these steps:</Typography>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 26.8,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <Box sx={{ display: 'flex', gap: '10px', alignItems: "center" }}>
                                    <Typography>1. Registered for</Typography>
                                    <FormControlLabel control={<Checkbox checked={form?.registered_for_thesis || ''} onChange={(e) =>
                                        setForm({ ...form, registered_for_thesis: e.target.checked })
                                    } disabled={view} />} label='Thesis' />
                                    <FormControlLabel control={<Checkbox checked={form?.registered_for_independent_study || ''} onChange={(e) =>
                                        setForm({ ...form, registered_for_independent_study: e.target.checked })
                                    } disabled={view} />} label='Independent Study' />
                                </Box>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            seq: 27,
                            type: "DATE",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                onChange: (e) => {
                                    setForm({ ...form, when_date: moment(e).format('YYYY-MM-DD') })
                                },
                                heading: 'When',
                                placeholder: 'When',
                                allowClear: true,
                                onClear: () => {
                                    setForm({ ...form, when_date: '' })
                                },
                                value: form?.when_date,
                                disabled: view
                            }

                        },
                        // {
                        //     seq: 27.1,
                        //     type: "DATE",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 4
                        //     },
                        //     hidden: ![20].includes(visaForm?.id_visa_type),
                        //     fieldProps: {
                        //         onChange: (e) => {
                        //             setForm({ ...form, semester: moment(e).format('YYYY-MM-DD') })
                        //         },
                        //         heading: 'Semester',
                        //         placeholder: 'Semester',
                        //         allowClear: true,
                        //         onClear: () => {
                        //             setForm({ ...form, semester: '' })
                        //         },
                        //         value: form?.semester,
                        //         disabled: view
                        //     }

                        // },
                        {
                            seq: 27.2,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                labelId: "ss",
                                heading: "Semester",
                                onChange: (e) => {
                                    setForm({ ...form, semester: e.target.value })
                                },
                                options: [1, 2, 3].map((item: any) => {
                                    return {
                                        label: item,
                                        value: item,
                                    }
                                }),
                                selectId: "",
                                value: form?.semester,
                                disabled: view
                            }
                        },
                        {
                            seq: 27.2,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                labelId: "ss",
                                heading: "Academic Year",
                                onChange: (e) => {
                                    setForm({ ...form, academic_year: e.target.value || '' })
                                },
                                options: academicYear.map((item: any) => {
                                    return {
                                        label: item?.academic_year,
                                        value: item?.id_academic_year,
                                    }
                                }),
                                selectId: "",
                                value: form?.academic_year,
                                disabled: view
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 28,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Typography >2. Let the college registrar check the printed document</Typography>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            seq: 28.1,
                            type: "DATE",
                            gridProps: {
                                xs: 12,
                                // md: 4
                            },
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                onChange: (e) => {
                                    setForm({ ...form, let_college_registrar_printed_date: moment(e).format('YYYY-MM-DD') })
                                },
                                heading: 'Date',
                                placeholder: 'Date',
                                allowClear: true,
                                onClear: () => {
                                    setForm({ ...form, let_college_registrar_printed_date: '' })
                                },
                                value: form?.let_college_registrar_printed_date,
                                disabled: view
                            }

                        },
                        {
                            type: "COMPONENT",
                            seq: 28.2,
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <Box sx={{ display: 'flex', gap: '10px', alignItems: "center" }}>
                                    <Typography>3. Send</Typography>
                                    <FormControlLabel control={<Checkbox checked={form?.send_thesis || ''} onChange={(e) =>
                                        setForm({ ...form, send_thesis: e.target.checked })
                                    } disabled={view} />} label='Thesis' />
                                    <FormControlLabel control={<Checkbox checked={form?.send_independent_study || ''} onChange={(e) =>
                                        setForm({ ...form, send_independent_study: e.target.checked })
                                    } disabled={view} />} label='Independent Study that has been properly arranged to the college registrar.' />
                                </Box>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            seq: 28.3,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                            },
                            hidden: ![20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                heading: "Quantity (sets)",
                                onChange: (e) => {
                                    setForm({ ...form, send_quantity: e.target.value })
                                },
                                value: form?.send_quantity,
                                onkeypress: handleTypingNumber,
                                disabled: view
                                // multiline: true,
                                // minRow: 6,
                                // inputHeight: 'auto'
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 29,
                            hidden: [20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Typography>Visa in Thailand (in case already got ED Visa or extension) *For M.A & Ph.D. only* Are you finishing Course Work?</Typography>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        onChange={(e) => {
                                            setForm({ ...form, visa_in_thai: e.target.value === 'true' ? true : false })
                                        }}
                                        value={form?.visa_in_thai || false}
                                    >
                                        <FormControlLabel value={true} disabled={view} control={<Radio />} label="yes" />
                                        <FormControlLabel value={false} disabled={view} control={<Radio />} label="no" />
                                    </RadioGroup>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },

                        {
                            type: "COMPONENT",
                            seq: 30,
                            hidden: [20].includes(visaForm?.id_visa_type),
                            fieldProps: {
                                element: <>
                                    <Typography>I prefer to receive letter at.... <span style={{ color: 'red' }}>*</span></Typography>
                                    <RadioGroup
                                        onChange={(e) => {
                                            setForm({ ...form, receive_letter: e.target.value === 'true' ? true : false })
                                        }}
                                        value={form?.receive_letter || false}
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value={true} disabled={view} control={<Radio />} label="IBSC office, the second floor, MCU Wangnoi, Thailand (work hours: MON-FRI from 09.00 a.m. - 05.00 p.m. Except Buddhist Holy Day, 
Sunday, Holiday, Government Issuance Day and University Issuance Day)" />
                                        <FormControlLabel value={false} disabled={view} control={<Radio />} label="Online by e-Letters (Only for students who stay abroad)" />
                                    </RadioGroup>
                                </>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                    ]} />
            </Grid>
            <Grid item xs={12} md={3}>
                <Box sx={{
                    border: '1px solid #DDE1EB',
                    borderRadius: '18px', overflow: 'hidden'
                }}>
                    <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ fontWeight: "600", color: '#fff' }}>File</Typography>
                    </Box>
                    <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {visaFormDocuments?.filter((x: any) => x?.id_visa_step === 1)?.length > 0 ? visaFormDocuments?.filter((x: any) => x?.id_visa_step === 1)?.sort((a: any, b: any) => a?.seq - b?.seq)?.map((item: any, index: number) => {
                            return (
                                <UploadFile item={item} index={index} setVisaFormDocuments={setVisaFormDocuments} view={view} isEdit={true} findById={getVisaForm} />
                            )
                        }) : <UploadFile view={true} />}
                    </Box>
                </Box>
            </Grid>

        </Grid >

    )
}
const UploadFile = (props: any) => {
    const { item, index, setVisaFormDocuments, view, isEdit, findById } = props
    const fileRef = useRef<any>()
    const { id } = useParams()
    const [pathUrl, setPathUrl] = useState<string>("");
    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
        };
        init();
    }, []);

    const onImageChange = async (event: any) => {
        if (event.target.files && event.target.files[0]) {
            // const formData = new FormData();

            // //DRAFT
            // formData.append('file', event.target.files[0]);
            // formData.append('id_admission_student', `${id}`);

            // await AdmissionFrontApi.student_file(formData).then((res: any) => {
            //     if (res.status < 300) {
            //         setForm({ ...form, admission_student_file: form?.admission_student_file?.length > 0 ? [...form?.admission_student_file, { ...res.data.data, id_document: item?.id_document }] : [{ ...res.data.data, id_document: item?.id_document }] })
            //         // console.log(res.data);
            //         if (fileRef.current) {
            //             fileRef.current.value = null;
            //         }

            //         // swalSuccess('ยืนยันการชำระเงิน', 'ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ')
            //     }
            // }).catch((error: any) => {
            //     console.log(error)
            //     if (fileRef.current) {
            //         fileRef.current.value = null;
            //     }
            //     swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            // })


            setVisaFormDocuments((prevData: any) =>
                prevData.map((q: any) =>
                    item?.id_visa_form_document === q?.id_visa_form_document
                        ? {
                            ...q,
                            visa_request_documents: q.visa_request_documents?.length > 0 ? [...q.visa_request_documents, event.target.files[0]] : [event.target.files[0]]
                        }
                        : q
                )
            );
            if (fileRef.current) {
                fileRef.current.value = "";
            }
        }
    }
    function formatBytes(bytes: any, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }

    const deleteFile = async (id_visa_request: any, id_visa_request_document: any) => {
        await VisaRequestFrontApi.deleteFile(id_visa_request, id_visa_request_document).then((res: any) => {
            findById()
            swalSuccess('ลบเรียบร้อย')
        }).catch((err) => {
            console.log(err);
            alertError("Save Draft", err?.response?.data?.message || "Error");
        })
    }
    console.log(item);
    return (
        <Box sx={{
            padding: '10px 15px', border: '1px solid #DDE1EB',
            borderRadius: '8px',
            display: "flex",
            flexDirection: 'column'
        }}>
            <Box sx={{ width: "100%" }}>
                <Box sx={{ display: "flex", gap: "10px", alignItems: "center", }}>
                    {!view ?
                        // item?.visa_request_documents?.length > 0 ?
                        item?.is_auto ? <CheckBoxIcon sx={{ color: '#5FB95D' }} /> :
                            //     isEdit ? */}
                            <AddBoxIcon sx={{ color: '#5FB95D', cursor: "pointer" }} onClick={() => fileRef.current.click()} /> : item?.visa_request_documents?.length > 0 ? <CheckBoxIcon sx={{ color: '#5FB95D' }} /> : <IndeterminateCheckBoxIcon sx={{ color: '#FF0000' }} />
                    }
                    <Typography sx={{
                        // whiteSpace: "nowrap", 
                        width: '100%', overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: "1",
                    }}>{item?.document_name || 'File upload field'}<span style={{ color: "red", marginLeft: '10px' }}>{item?.is_req ? '*' : ''}</span></Typography>
                </Box>

                {/* {form?.find((x: any) => x?.id_document === item?.id_document) && <Typography>{form?.admission_student_file?.find((x: any) => x?.id_document === item?.id_document)?.file_name} {formatBytes(form?.admission_student_file?.find((x: any) => x?.id_document === item?.id_document)?.file_size)}</Typography>} */}
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", }}>
                {item?.visa_request_documents ? item?.visa_request_documents?.map((x: any, ix: number) => {
                    return (
                        <Box sx={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: 'space-between' }}>
                            <Typography sx={{
                                width: '100%', overflow: "hidden",
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: "1",
                            }}>{x?.name || x?.file_name} {formatBytes(x?.size || x?.file_size)}</Typography>
                            <OptionsButtonCustom
                                // enableEdit
                                enableView
                                enableDelete={!(item?.is_auto || view)}
                                onViewClick={() => { window.open(x?.id_visa_request_document ? `${pathUrl}/${x?.file_path}${x?.file_name}` : URL.createObjectURL(x), '_blank') }}
                                // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}
                                onDeleteClick={() => {
                                    if (x?.id_visa_request_document) {
                                        deleteFile(x?.id_visa_request, x?.id_visa_request_document)
                                    } else {
                                        setVisaFormDocuments((prevData: any) => {
                                            return prevData?.sort((a: any, b: any) => a?.seq - b?.seq)?.map((q: any, i: number) => {
                                                return index === i ? { ...q, visa_request_documents: q?.visa_request_documents.filter((c: any, iy: number) => ix !== iy) } : q
                                            }

                                            )
                                        })
                                    }

                                }}
                            />
                        </Box>
                    )
                }) : <></>}


            </Box>

            {/* <ContainerButton
                justifyContent='flex-end'
                buttonData={[
                    {
                        buttonProps: {
                            onClick: () => { fileRef.current.click() }
                        },
                        key: "IMPORT_EXCEL",
                        label: 'Upload',
                        seq: 1,
                        type: "IMPORT_EXCEL"
                    }
                ]}
            /> */}
            <input ref={fileRef} className='hidden' type='file'
                // accept={"image/*"} 
                onChange={(e: any) => onImageChange(e)} />
        </Box>
    )
}